import {Link} from "react-router";
import {useContext, useEffect, useState} from "react";
import {SelectedActivities} from "../components/SelectedActivities.tsx";
import ActivityContext, {IResolvedActivity} from "../contexts/Activity.tsx";
import {calcItem} from "../helpers/calcItem.ts";
import {isMobile} from "../helpers/isMobile.ts";
import GeneralContext from "../contexts/Gneral.tsx";

export function FinalActivites () {
    const  data  = useContext(GeneralContext);
    const {resolvedActivities}  = useContext(ActivityContext);
    const [hideInactive, setHideInactive] = useState<boolean>(true);
    const [useScale, setUseScale] = useState<boolean>(true);
    const [toFirstLevel, setToFirstLevel] = useState<boolean>(false);
    const [firstLevel, setFirstLevel] = useState<SVGPathElement | null>(null);

    const DISTINCTION = isMobile() ? 0 : 125;
    let _resolvedActivities = resolvedActivities.map( (item) => {
        return Object.assign({},calcItem(item));
    }).sort((a,b)=> a.r > b.r ? 1 : -1);
    // if(toFirstLevel){
    //     // @ts-ignore
    //     const line = window.svgEl.querySelector('path.inner-line') as SVGPathElement;
    //     // @ts-ignore
    //     const size = window.svgEl.getBoundingClientRect();
    //     const container = document.querySelector('.halo');
    //     const containerParent = document.querySelector('.personArea');
    //     const containerSize = container.getBoundingClientRect();
    //
    //     const dx = containerParent.clientWidth/2 - container.clientWidth/2;
    //     const dy = containerParent.clientHeight/2 - container.clientHeight/2;
    //     _resolvedActivities = _resolvedActivities.map((item,index) =>{
    //         if(firstLevel){
    //             firstLevel.style.strokeWidth='10px';
    //             const length = line.getTotalLength();
    //             const point = line.getPointAtLength(length / 5 * index);
    //             item.position = Object.assign({},item.position);
    //             item.position.x = point.x -DISTINCTION + dx /* + (container.clientWidth  - window.svgEl.clientWidth) * k * ( kx < ky ? 1 : -1)*/ ;
    //             item.position.y = point.y -DISTINCTION + dy  /*+ (container.clientHeight - window.svgEl.clientHeight) *k * (ky < kx ? -1 : 1)*/;
    //         }
    //         return calcItem(item);
    //     });
    // }

    let scale = 0
    _resolvedActivities.slice(0,5).forEach((item) => {
        if(scale < item.scale){
            scale = item.scale
        }
    })
    // const el = document.querySelector('.selectingAside');
    // let clientHeight = el?.clientHeight && isMobile() ? (window.innerHeight * 0.59 - (window.innerHeight - el.clientHeight))/2 : 0;
    useEffect(() => {


    }, []);
    scale = 1/(scale)* (isMobile() ? 0.7 : 0.8)
    useEffect(() => {
        setTimeout(()=>{
            setHideInactive(false);
            setUseScale(false);
        },1000);
        setTimeout(()=>{
            setHideInactive(true);
            setUseScale(true);
            setToFirstLevel(true);
        },3000);
    }, []);
    return (<div  className={'builder-screen'}>
            <div className={'selectingAside'}>
                <div className={'aside-content'}>
                    <h1>{data?.contents.finalActivitiesScreenHeading}</h1>
                </div>
                <ul className={"final-activities"}>
                    {_resolvedActivities.slice(0,5).map((item, index) =>{
                        return <li key={index}><strong>{item.activity.title}</strong></li>
                    })}
                </ul>
                <Link to={"/select-skill"} className={"btn"}>בואו נמשיך</Link>
            </div>
            <div className={'visualArea'}>
                {/*<SelectedActivities offsetY={-clientHeight} activities={_resolvedActivities} scale={useScale ? scale : 1} hideInactive={hideInactive} firstLevel={firstLevel} setFirstLevel={setFirstLevel} />*/}
                <SelectedActivities activities={_resolvedActivities} scale={useScale ? scale : 1} hideInactive={hideInactive} firstLevel={firstLevel} setFirstLevel={setFirstLevel} />
            </div>
    </div>);
}